import { useEffect } from 'react';

import { LoadingOverlay } from '@/components/common/loading-overlay';
import { useAuthStore } from '@/state/store/auth';
import { UserRole } from '@/state/store/auth/index.type';
import { useNavigate } from 'react-router-dom';
import { AdminShell } from '../components/admin-shell';

const SYSTEM_ADMIN_ORG_ID = import.meta.env.VITE_SYSTEM_ADMIN_ORG_ID;
const SYSTEM_ADMIN_ORG_SLUG = import.meta.env.VITE_SYSTEM_ADMIN_ORG_SLUG;

export default function AdminLayoutPage() {
  const router = useNavigate();

  const { userId, platformRole, isAuthLoading, user, orgId, setOrg, logout } = useAuthStore();

  // Set system admin org when entering the admin route
  useEffect(() => {
    if (!user) return;

    const hasSystemAdmin = user.memberships?.some((m) => m.organizationId === SYSTEM_ADMIN_ORG_ID);

    if (hasSystemAdmin) {
      if (orgId !== SYSTEM_ADMIN_ORG_ID) {
        setOrg(SYSTEM_ADMIN_ORG_ID, SYSTEM_ADMIN_ORG_SLUG, SYSTEM_ADMIN_ORG_ID);
      }
    } else {
      router('/login');
      logout();
      return;
    }
  }, [user, orgId, setOrg, logout, router]);

  if (!userId) {
    router('/login');
  }

  const role = platformRole;

  if (!role) {
    router('/login');
  }

  if (isAuthLoading) {
    return <LoadingOverlay />;
  }

  return <AdminShell userRole={role as UserRole} />;
}
